import { API } from '../apis/limeAuthUtils/apiWrapper';

const API_NAME_PREFIX = 'v1/reservation-queue';

/**
 * Get queue configuration settings.
 * @param {string} region - Selected region
 * @returns {Promise<object>} Queue config
 */
export async function fetchQueueConfig(region) {
    const apiName = `${region}/${API_NAME_PREFIX}`;
    return await API.get(apiName, '/v1/queue/config', {});
}

/**
 * Update a single queue configuration setting.
 * @param {string} configKey - Setting key to update
 * @param {number|string} value - New value
 * @param {string} region - Selected region
 * @returns {Promise<object>} Success response
 */
export async function updateQueueConfig(configKey, value, region) {
    const apiName = `${region}/${API_NAME_PREFIX}`;
    const myInit = {
        body: { configKey, value },
    };
    return await API.post(apiName, '/v1/queue/config', myInit);
}

/**
 * Get queue metrics snapshot.
 * @param {string} region - Selected region
 * @returns {Promise<object>} Metrics
 */
export async function fetchQueueMetrics(region) {
    const apiName = `${region}/${API_NAME_PREFIX}`;
    return await API.get(apiName, '/v1/queue/metrics', {});
}

/**
 * Get all allocation overrides.
 * @param {string} region - Selected region
 * @returns {Promise<object>} List of overrides
 */
export async function fetchOverrides(region) {
    const apiName = `${region}/${API_NAME_PREFIX}`;
    return await API.get(apiName, '/v1/queue/overrides', {});
}

/**
 * Create or update an allocation override for a bot account.
 * @param {string} botAccount - Bot account username
 * @param {string} deviceType - Device type
 * @param {number} allocation - Allocation value
 * @param {string} reason - Justification
 * @param {string} region - Selected region
 * @returns {Promise<object>} Success response
 */
export async function createOverride(botAccount, deviceType, allocation, reason, region) {
    const apiName = `${region}/${API_NAME_PREFIX}`;
    const myInit = {
        body: { botAccount, deviceType, allocation, reason },
    };
    return await API.post(apiName, '/v1/queue/overrides', myInit);
}

/**
 * Delete a specific allocation override.
 * @param {string} botAccount - Bot account username
 * @param {string} deviceType - Device type
 * @param {string} region - Selected region
 * @returns {Promise<object>} Success response
 */
export async function deleteOverride(botAccount, deviceType, region) {
    const apiName = `${region}/${API_NAME_PREFIX}`;
    const myInit = {
        body: { botAccount, deviceType },
    };
    return await API.del(apiName, '/v1/queue/overrides', myInit);
}
